import React, { useContext } from 'react';
import { renderCurrentDate, renderTime } from '../../../utils/date';
import CurrentTimeContext from '../../../context/TimeContext';

function CurrentTime() {
  const { currentDate } = useContext(CurrentTimeContext);

  return (
    <>
      <p>{renderTime(currentDate)}</p>
      <span>{renderCurrentDate(currentDate)}</span>
    </>
  );
}

export default CurrentTime;
